import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// project imports
import Loader from 'components/Loader';
import { SimpleLayoutType } from 'config';

const Header = lazy(() => import('components/pages/Header'));
const Header2 = lazy(() => import('components/pages/Header2'));
const Footer = lazy(() => import('components/pages/Footer'));
const Footer2 = lazy(() => import('components/pages/Footer2'));

type SimpleLayoutProps = {
  layout?: SimpleLayoutType;
  enableElevationScroll?: boolean;
};

// ==============================|| LAYOUT - SIMPLE / LANDING ||============================== //

export default function SimpleLayout({ layout = SimpleLayoutType.SIMPLE, enableElevationScroll = false }: SimpleLayoutProps) {
  return (
    <Suspense fallback={<Loader />}>
      <Header2 enableElevationScroll={enableElevationScroll} />
      <Outlet />
      <Footer2 isFull={layout === SimpleLayoutType.LANDING} />
    </Suspense>
  );
}
